import type { InvitationRole } from "../types";

export const invitationRoleLabel = (role: InvitationRole) =>
  role === "MANAGER" ? "Manager" : "Staff";

/** Appended to "invited to join <Company>"; a staff invitation stays as it reads. */
export const invitationRoleSuffix = (role: InvitationRole) =>
  role === "MANAGER" ? " as a manager" : "";
